import Vue from 'vue'

export default el => Promise.all([
]).then(() => new Vue({ el }))
